module.exports = __webpack_public_path__ + "static/media/receipt.a107a9bc.svg";